import { Quote, Star } from "lucide-react";
import { Reveal } from "./shared";

const reviews = [
  { name: "Jennifer M.", area: "Windermere", text: "Tanya and her team are so gentle and thorough. My home has never felt this fresh — they truly care about every corner." },
  { name: "David & Sara", area: "Downtown Edmonton", text: "Booked a deep clean before moving in. Absolutely spotless, on time, and so kind. We now have them come monthly." },
  { name: "Olena K.", area: "Terwillegar", text: "The attention to detail is unreal. Everything is neat, calm and beautifully clean. Highly recommend to anyone in Edmonton." },
];

export default function Testimonials() {
  return (
    <section id="testimonials" data-testid="testimonials-section" className="bg-blush py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal className="text-center max-w-2xl mx-auto mb-16">
          <p className="text-sm uppercase tracking-[0.25em] text-teal font-semibold mb-4">Kind Words</p>
          <h2 className="font-serif-display text-4xl sm:text-5xl text-teal font-medium">
            Loved by Edmonton homes
          </h2>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {reviews.map((r, i) => (
            <Reveal key={r.name} delay={i * 0.12}>
              <div
                data-testid={`testimonial-${i}`}
                className="h-full bg-white rounded-3xl p-8 shadow-[0_10px_40px_rgba(43,81,86,0.06)]"
              >
                <Quote size={32} className="text-pink" strokeWidth={1.5} />
                <div className="flex text-pink my-4">
                  {[...Array(5)].map((_, s) => (
                    <Star key={s} size={16} fill="#E1AFC0" strokeWidth={0} />
                  ))}
                </div>
                <p className="text-teal-soft leading-relaxed italic">“{r.text}”</p>
                <div className="mt-6 pt-5 border-t border-blush">
                  <p className="font-serif-display text-xl text-teal">{r.name}</p>
                  <p className="text-sm text-pink-dark">{r.area}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
